import FormationGalery from './FormationGalery';

export default FormationGalery;
